import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ThreadOutlineIcon = (props: IconProps) => (
  <Icon width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <path d="M16.6666 1.66666H3.33329c-.91666 0-1.66666.75-1.66666 1.66666V18.3333L4.99996 15H16.6666c.9167 0 1.6667-.75 1.6667-1.6667V3.33332c0-.91666-.75-1.66666-1.6667-1.66666Zm0 11.66664H4.99996L3.33329 15V3.33332H16.6666v9.99998Z" />
  </Icon>
);

export default memo(ThreadOutlineIcon);
